import { CustomStage } from '@/utils/constants';

export const CUSTOM_STAGES: Record<CustomStage, string> = {
	NEW: 'New',
	SHORTLISTED: 'Shortlisted',
	ARCHIVED: 'Archived',
};
export const CUSTOM_STAGE_ACTIONS: Record<CustomStage, string> = {
	NEW: 'New',
	SHORTLISTED: 'Shortlist',
	ARCHIVED: 'Archive',
};

export const STAGE_VERBS = {
	[CUSTOM_STAGES.NEW]: {
		past: 'New',
		present: 'New',
		processing: 'New',
	},
	[CUSTOM_STAGES.SHORTLISTED]: {
		past: 'Shortlisted',
		present: 'Shortlist',
		processing: 'Shortlisting',
	},
	[CUSTOM_STAGES.ARCHIVED]: {
		past: 'Archived',
		present: 'Archive',
		processing: 'Archiving',
	},
};
